import { render, staticRenderFns } from "./menu2_images_scence.vue?vue&type=template&id=4d2a622a&scoped=true"
import script from "./menu2_images_scence.vue?vue&type=script&lang=js"
export * from "./menu2_images_scence.vue?vue&type=script&lang=js"
import style0 from "./menu2_images_scence.vue?vue&type=style&index=0&id=4d2a622a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a622a",
  null
  
)

export default component.exports